import { Loader2 } from "lucide-react"
import React from "react"
import { cn } from "../../utils/cn"

/**
 * Esqueleto animado no lugar do QR code enquanto o servidor gera a cobrança
 * (com PIX_MOCK o backend segura a resposta de propósito para simular o banco).
 */
const PixQrSkeleton: React.FC<{ size?: number; label?: string; className?: string }> = ({
    size = 160,
    label = "Gerando cobrança PIX...",
    className,
}) => {
    const cells = 9
    return (
        <div className={cn("flex flex-col items-center gap-3", className)}>
            <div
                className="relative overflow-hidden rounded-xl border-2 border-border bg-white p-4"
                style={{ width: size + 32, height: size + 32 }}
                aria-busy="true"
                aria-label={label}
            >
                <div
                    className="grid h-full w-full gap-[3px]"
                    style={{
                        gridTemplateColumns: `repeat(${cells}, minmax(0, 1fr))`,
                    }}
                >
                    {Array.from({ length: cells * cells }, (_, i) => {
                        // Cantos "âncora" de QR + miolo pseudoaleatório determinístico.
                        const r = Math.floor(i / cells)
                        const c = i % cells
                        const corner =
                            (r < 3 && c < 3) ||
                            (r < 3 && c >= cells - 3) ||
                            (r >= cells - 3 && c < 3)
                        const on = corner || (i * 7919) % 5 < 2
                        return (
                            <div
                                key={i}
                                className={cn(
                                    "rounded-[2px]",
                                    on ? "bg-neutral-300" : "bg-transparent"
                                )}
                            />
                        )
                    })}
                </div>
                {/* Faixa de brilho varrendo (shimmer) */}
                <div className="pointer-events-none absolute inset-y-0 -left-1/2 w-1/2 animate-[pix-shimmer_1.4s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/90 to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-fg shadow-lg">
                        <Loader2 className="h-6 w-6 animate-spin" />
                    </span>
                </div>
            </div>
            <span className="text-xs text-muted">{label}</span>
        </div>
    )
}

export default PixQrSkeleton
